import { authHeader, handleResponse } from '../helpers'

export const productService = {
    getProducts,
    getProduct,
    syncProducts,
};

function getProducts() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(process.env.VUE_APP_API_URL + `/product`, requestOptions)
    .then(handleResponse)
    .then(response => {
        return response;
    });
}

function getProduct(productId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(process.env.VUE_APP_API_URL + `/product/${productId}`, requestOptions)
    .then(handleResponse)
    .then(response => {
        return response;
    });
}

function syncProducts() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(process.env.VUE_APP_API_URL + `/product/sync`, requestOptions)
    .then(handleResponse)
    .then(response => {
        return response;
    });
}
